import { useState } from "react";
import Button from "components/shared/Button";
import { DevelopersHeroImage, DevelopersHeroImageMobile } from "assets/images";
import ApplyForFundingForm from "./fundingForm/ApplyForFundingForm";
const Hero = () => {
  const [showForm, setShowForm] = useState(false);
  return (
    <section className='bg-[url(../src/assets/images/developersbackgroundimage.png)] bg-no-repeat bg-cover'>
      <div className='py-8 px-4 md:px-16'>
        <div className='flex flex-col justify-center items-center gap-8 referral-container'>
          <div className='flex flex-col gap-6 md:gap-8 md:w-[740px] text-center'>
            <p className='text-blueShades-4 text-5xl font-SatoshiBold md:w-[704px] m-auto'>
              Deliver projects profitably with smart tools and resources.
            </p>
            <p className='text-ashShade-16 text-xl md:text-lg font-SatoshiMedium md:w-[660px] m-auto'>
              Access finance and gain effective control of project cost, track
              real-time and speed up progress, ensure quality, and manage
              granular details of procurement.
            </p>
          </div>
          <div className='flex flex-col w-full md:w-auto md:flex-row md:items-center gap-4 md:gap-6'>
            <a
              href={`https://auth.${process.env.REACT_APP_DOMAIN}/project-owner/signup?fromreferralPage=true`}
              rel='noopener noreferrer'
              className='flex flex-col'
            >
              <Button
                label='Create a Project '
                type='transparent'
                style={{
                  backgroundColor: "transparent",
                  borderWidth: "1px",
                  borderColor: "#D1D5DB",
                  color: "#112F5D",
                }}
              />
            </a>
            <Button
              label='Apply for Funding'
              style={{
                backgroundColor: "#023061",
                borderColor: "#023061",
              }}
              onClick={() => setShowForm(true)}
            />
          </div>
          <img
            src={DevelopersHeroImage}
            alt='Hero Banner'
            className='hidden md:block'
          />
          <img
            src={DevelopersHeroImageMobile}
            alt='Hero Banner'
            className='md:hidden'
          />
        </div>
      </div>
      {showForm && <ApplyForFundingForm closer={setShowForm} />}
    </section>
  );
};
export default Hero;
